module.exports = __webpack_public_path__ + "static/media/fresno_nordico.afdd7d69.jpg";